import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { LoggerService } from 'shared/core/services/logger.service';
import { TenantService } from 'shared/core/services/tenant/tenant.service';
import { UserService } from 'shared/core/services/user/user.service';
/**
 * CanActivate implementation to check the user and validate tenant context
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
        private userService: UserService,
        private router: Router,
        private tenantService: TenantService,
        private logger: LoggerService
    ) {}
    /**
     * This canActivate is called on AppRoutingModule (when the path is not /login or /logout) and on routes (/dashboard)
     * If the token isn't in localStorage we call access/recover and set the data on UserService.
     * If the token exists but the user was not defined, we call access/recover anyway
     */
    async canActivate(
        _route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        this.logger.debug('[AuthGuard] Checking access for:', state.url);

        const authenticated = await this.userService.checkAuthenticationAsPromise(
            state.url
        );
        this.logger.debug('[AuthGuard] Authentication status:', authenticated);

        if (!authenticated) {
            this.logger.info('[AuthGuard] User not authenticated, redirecting to login');
            this.router.navigate(['/login'], {
                queryParams: { returnUrl: state.url },
            });
            return false;
        }

        // Multi-tenancy validation: Check if user's tenant matches subdomain
        const user = this.userService.user;

        if (!user.tenant_id) {
            return false;
        }
        console.log('[AuthGuard] Authenticated');
        return authenticated;
    }
}
